import gql from 'graphql-tag';
import { useQuery, useMutation } from '@vue/apollo-composable';
import { ref, watch } from 'vue';
import { useProfileInfo } from '@models/profile/useCurrentProfile';

export type userGroup = {
    id: string;
    name: string;
    source: string;
    content: Object;
    description: string;
    users?: number;
    actives?: number;
    newActives?: number;
    guideType?: string;
    engagements?: number;
};

export type UsergroupCreateInput = {
    sid: string;
    name: string;
    content?: Object;
    description?: string;
    guideType?: string;
};

export const USERGROUP_QUERY = gql`
    query getUserGroupListByProfileId {
        getUserGroupListByProfileId {
            id
            name
            source
            content
            description
        }
    }
`;

export const CREATE_USERGROUP_MUTATION = gql`
    mutation createUsergroup($data: UsergroupCreateInput!) {
        createUsergroup(data: $data) {
            id
            name
            source
            content
            description
        }
    }
`;
const { profileChangeLoading, profileInfo } = useProfileInfo();
const allUsergroups = ref<userGroup[]>();
const userGroupsLoading = ref(false);

// 切换档案清除数据
watch(
    () => profileChangeLoading.value,
    newStatus => {
        !newStatus && getAllUserGroups();
    }
);
function getAllUserGroups(
    resultCallback?: (T: userGroup[] | null) => void,
    rejectCallback?: (err: any) => void
) {
    userGroupsLoading.value = true;
    const { onError: onUserGroupsError, onResult: onUserGroupsResult } = useQuery<{
        getUserGroupListByProfileId: userGroup[];
    }>(USERGROUP_QUERY, null, {
        fetchPolicy: 'no-cache'
    });

    onUserGroupsResult(data => {
        if (data?.data?.getUserGroupListByProfileId) {
            allUsergroups.value = data?.data?.getUserGroupListByProfileId;
            userGroupsLoading.value = false;
            resultCallback &&
                typeof resultCallback === 'function' &&
                resultCallback(allUsergroups.value);
        }
    });
    onUserGroupsError(err => {
        rejectCallback && typeof rejectCallback === 'function' && rejectCallback(err);
        userGroupsLoading.value = false;
    });
}
export function useAllUserGroups() {
    const {
        mutate: createUsergroupMutate,
        loading: creatUsergroupLoading,
        onDone: onCreateUsergroupDone
    } = useMutation(CREATE_USERGROUP_MUTATION);
    const createUsergroup = ($data: UsergroupCreateInput, onSuccess?: () => void) =>
        createUsergroupMutate({ data: $data });
    return {
        data: allUsergroups,
        userGroupsLoading,
        creatUsergroupLoading,
        getAllUserGroups,
        createUsergroup,
        onCreateUsergroupDone
    };
}
